import { createContext, useContext, useEffect, useState } from "react";
import {
  fetchAllProducts,
  fetchCourseByName,
  fetchCategories,
} from "../api/ProductApi";

const ProductContext = createContext();
export const useProducts = () => useContext(ProductContext);

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]); 
  const [loading, setLoading] = useState(true);

  const getProducts = async () => {
    try {
      const data = await fetchAllProducts();
      setProducts(data);
    } catch (error) {
      console.error("Failed to fetch products", error);
    } finally {
      setLoading(false);
    }
  };

 
  const getCategories = async () => {
    try {
      const data = await fetchCategories();

      const catList = data
        .map((cat) => cat?.category_name)
        .filter(
          (name) => typeof name === "string" && name.trim() !== ""
        );

      setCategories(["All", ...catList]);
    } catch (error) {
      console.error("Failed to fetch categories", error);
    }
  };


  const getCourseByName = async (name) => {
    try {
      const data = await fetchCourseByName(name);
      return data;
    } catch (error) {
      console.error("Failed to fetch course by name", error);
      return null;
    }
  };


  useEffect(() => {
    getProducts();
    getCategories();
  }, []);

  return (
    <ProductContext.Provider
      value={{
        products,
        categories, 
        getCourseByName,
        loading,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};
